import { render, staticRenderFns } from "./Type4.vue?vue&type=template&id=2d12369a&scoped=true"
import script from "./Type4.vue?vue&type=script&lang=js"
export * from "./Type4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12369a",
  null
  
)

export default component.exports